import React from 'react';
import { CtaButton } from './CtaButton';
import { SectionWrapper } from './SectionWrapper';
import { Lock, Download, ShieldCheck } from 'lucide-react';
export const Hero: React.FC = () => {
  return <SectionWrapper className="pt-12 md:pt-24" data-id="element-90">
      <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-91">
        {/* Content Column */}
        <div className="flex-1 flex flex-col gap-6 order-2 lg:order-1" data-id="element-92">
          <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight" data-id="element-93">
            VISA MASTER: El Protocolo de 5 Minutos
          </h1>

          <p className="text-xl md:text-2xl text-gold font-semibold leading-snug" data-id="element-94">
            El script exacto para responder las preguntas del cónsul y salir de
            la embajada con tu Visa aprobada — aunque hoy mueras de nervios.
          </p>

          {/* Top CTA — directly below subheadline, before image */}
          <div data-id="element-95">
            <CtaButton text="SÍ, QUIERO MI PROTOCOLO AHORA — $6.39" scrollToId="comprar" data-id="element-96" />
          </div>

          {/* Mobile Image Placement (between subhead and clarity box) */}
          <div className="block lg:hidden w-full max-w-md mx-auto my-4" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/aShE4QvZtXpfW6rZhYhdGx/imagen_oficial_landing_page.png" alt="Visa Master Protocolo" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-98" />
          </div>

          {/* Clarity Box */}
          <div className="border-4 border-gold p-6 rounded-lg bg-navy-light/50 shadow-lg" data-id="element-99">
            <p className="text-lg md:text-xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-100">
              <span data-id="element-101">📦</span> LO QUE RECIBES:
            </p>
            <ul className="text-lg text-gray-200 space-y-2 font-medium" data-id="element-102">
              <li data-id="element-103">• 1 PDF descargable + 1 Audio de entrenamiento</li>
              <li data-id="element-104">• Entrega por email en menos de 5 minutos</li>
              <li data-id="element-105">• Precio: $6.39</li>
              <li data-id="element-106">• Garantía de 7 días</li>
            </ul>
          </div>

          <div className="mt-4" data-id="element-107">
            <CtaButton text="SÍ, QUIERO MI PROTOCOLO AHORA — $6.39" scrollToId="comprar" data-id="element-108" />

            {/* Trust Line */}
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-6 text-sm md:text-base text-gray-300 font-medium" data-id="element-109">
              <div className="flex items-center gap-1.5" data-id="element-110">
                <Lock size={18} className="text-gold" data-id="element-111" />
                <span data-id="element-112">Pago Seguro</span>
              </div>
              <span className="hidden sm:inline text-gray-500" data-id="element-113">•</span>
              <div className="flex items-center gap-1.5" data-id="element-114">
                <Download size={18} className="text-gold" data-id="element-115" />
                <span data-id="element-116">Descarga Inmediata</span>
              </div>
              <span className="hidden sm:inline text-gray-500" data-id="element-117">•</span>
              <div className="flex items-center gap-1.5" data-id="element-118">
                <ShieldCheck size={18} className="text-gold" data-id="element-119" />
                <span data-id="element-120">Garantía 7 Días</span>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Image Column */}
        <div className="flex-1 hidden lg:block order-1 lg:order-2" data-id="element-121">
          <img src="https://cdn.magicpatterns.com/uploads/aShE4QvZtXpfW6rZhYhdGx/imagen_oficial_landing_page.png" alt="Visa Master Protocolo" className="w-full h-auto rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-122" />
        </div>
      </div>
    </SectionWrapper>;
};